<script>
import justifiedLayout from 'justified-layout'
import FileWrapper from '@/components/modules/Files/layouts/FileWrapper'

export default {
  name: 'LayoutJustified',
  inheritAttrs: false,
  functional: true,
  props: {
    rowsJustified: {
      type: Number,
      required: true
    },
    rowCadence: {
      type: Number,
      required: true
    },
    containerWidth: {
      type: Number,
      required: true
    }
  },
  render (createElement, context) {
    const files = context.children.filter(c => c.componentOptions)
    const justifiedOptions = {
      containerWidth: context.props.containerWidth,
      targetRowHeight: context.props.rowsJustified,
      fullWidthBreakoutRowCadence: context.props.rowCadence,
      containerPadding: {
        top: 10,
        right: 10,
        bottom: 10,
        left: 10
      },
      boxSpacing: {
        horizontal: 10,
        vertical: 10
      }
    }
    // when dropping files on existing justified layouts, rerendering happens before ratios are calculated, so we catch undefined ratios here
    const justifiedItems = files.map(f => f.componentOptions.propsData.ratio || 1)
    const justifiedGeometry = justifiedLayout(justifiedItems, justifiedOptions)
    const justifiedBoxes = justifiedGeometry.boxes.map((b, i) => {
      const obj = typeof justifiedItems[i] === 'object' ? justifiedItems[i] : {}
      return Object.assign(obj, {
        style: {
          height: `${b.height}px`,
          width: `${b.width}px`,
          top: `${b.top}px`,
          left: `${b.left}px`,
          position: 'absolute'
        }
      })
    })
    return files.map((f, i) => {
      return createElement(
        FileWrapper,
        {
          class: 'file',
          style: justifiedBoxes[i].style
        },
        [f])
    })
  }
}
</script>
